import Vue from "vue";
import Router from "vue-router";

import Bulk from "./views/Bulk";
import Signup from "./views/Signup";
import Signin from "./views/Signin";
import Timeslots from "./views/Timeslots";
import Leagues from "./views/Leagues";
import League from "./views/League";
import Dashboard from "./views/Dashboard";
import LeagueForm from "./views/LeagueForm";
import Season from "./views/Season";
import SeasonForm from "./views/SeasonForm";
import Division from "./views/Division";
import DivisionForm from "./views/DivisionForm";
import Team from "./views/Team";
import TeamForm from "./views/TeamForm";
import Person from "./views/Person";
import PersonEdit from "./views/PersonEdit";
import Venue from "./views/Venue";
import VenueForm from "./views/VenueForm";
import ScheduleForm from "./views/ScheduleForm";
import Schedule from "./views/Schedule";
import Embed from "./views/Embed";
import ScheduleList from "./views/ScheduleList";
import ConnectSportsengine from "./views/ConnectSportsengine";
import Blank from "./views/Blank";
import Import from "./views/Import";
import Calendar from "./views/Calendar";
import Setup from "./views/Setup";
import Callback from "./views/Callback";
import Reset from "./views/Reset";
import Wizard from "./views/Wizard";
import SportsEngine from "./views/SportsEngine";
import SportsEngineImport from "./views/SportsEngineImport";
import SportsEngineExport from "./views/SportsEngineExport";
import SportsEngineDelete from "./views/SportsEngineDelete";
import Billing from "./views/Billing";
import Admin from "./views/Admin";
import CSV from "./views/CSV";
import Password from "./views/Password";
import Account from "./views/Account";
import Activity from "./views/Activity";
import Organization from "./views/Organization";
import Invitation from "./views/Invitation";
import Toasted from "vue-toasted";
import store from "./store";
import Standings from "@/views/Standings.vue";
import PublicStandings from "@/views/PublicStandings.vue";
import "./assets/custom_toasted.css";
import PublicSchedules from "@/views/PublicSchedules.vue";
import PublicScores from "@/views/PublicScores.vue";
import TournamentForm from "@/views/TournamentForm.vue";
import TournamentList from "@/views/TournamentList.vue";
import EmailConfirmation from "@/views/EmailConfirmation.vue";
import SignupWizard from "@/views/SignupWizard.vue";
import PublicWebpage from "@/views/PublicWebpage.vue";
import api from "@/api";
import PublicHome from "@/views/PublicHome.vue";
import PublicTeam from "@/views/PublicTeam.vue";
import SportsEngineImportBeta from "@/views/SportsEngineImportBeta.vue";
import LeagueManagement from "@/views/LeagueManagement.vue";
import i18n from "@/lang";

Vue.use(Router);
Vue.use(Toasted, {
  position: "top-right",
  theme: "outline",
  duration: 5000,
});

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/password",
      component: Password,
      name: "Password",
    },
    {
      path: "/accept_invitation/:id",
      component: Invitation,
      name: "Invitation",
      beforeEnter: requireAuthWithToast,
    },
    {
      path: "/bulk",
      component: Bulk,
      name: "Bulk",
      beforeEnter: requireAuth,
    },
    {
      path: "/sportsengine/connect",
      component: ConnectSportsengine,
      name: "ConnectSportsengine",
    },
    {
      path: "/activity/:id",
      component: Activity,
      name: "Activity",
    },
    {
      path: "/account",
      component: Account,
      name: "Account",
    },
    {
      path: "/organization",
      component: Organization,
      name: "Organization",
      beforeEnter: requireAuth,
    },
    {
      path: "/sportsengine",
      component: SportsEngine,
      name: "SportsEngine",
      beforeEnter: requireAuth,
    },
    {
      path: "/import/csv",
      component: CSV,
      name: "CSV",
      beforeEnter: requireAuth,
    },
    {
      path: "/dropshadows",
      component: Admin,
      name: "Admin",
      beforeEnter: requireAuth,
    },
    {
      path: "/sportsengine/import",
      component: SportsEngineImport,
      name: "SportsEngineImport",
      beforeEnter: requireAuth,
    },
    {
      path: "/sportsengine/import-beta",
      component: SportsEngineImportBeta,
      name: "SportsEngineImportBeta",
      beforeEnter: requireAuth,
    },
    {
      path: "/sportsengine/export",
      component: SportsEngineExport,
      name: "SportsEngineExport",
      beforeEnter: requireAuth,
    },
    {
      path: "/sportsengine/delete",
      component: SportsEngineDelete,
      name: "SportsEngineDelete",
      beforeEnter: requireAuth,
    },
    {
      path: "/setup",
      component: Setup,
      name: "Setup",
      beforeEnter: requireAuth,
    },
    {
      path: "/wizard",
      component: Wizard,
      name: "Wizard",
    },
    {
      path: "/billing",
      component: Billing,
      name: "Billing",
      beforeEnter: requireAuth,
    },
    {
      path: "/oauth/callback",
      component: Callback,
      name: "Callback",
    },
    {
      path: "/reset",
      component: Reset,
      name: "Reset",
    },
    {
      path: "/schedules/new",
      component: ScheduleForm,
      name: "ScheduleNew",
      beforeEnter: requireAuth,
    },
    {
      path: "/tournaments/new",
      component: TournamentForm,
      name: "TournamentNew",
      beforeEnter: requireAuth,
    },
    {
      path: "/blank",
      component: Blank,
      beforeEnter: requireAuth,
    },
    {
      path: "/embed/:id",
      name: "Embed",
      component: Embed,
    },
    {
      path: "/import",
      component: Import,
      beforeEnter: requireAuth,
    },
    {
      path: "/calendar",
      component: Timeslots,
      beforeEnter: requireAuth,
      name: "Master",
    },
    {
      path: "/standings",
      component: Standings,
      beforeEnter: requireAuth,
      name: "Standings",
    },
    {
      path: "/list",
      component: Schedule,
      beforeEnter: requireAuth,
      name: "List",
    },
    {
      path: "/league-management",
      component: LeagueManagement,
      beforeEnter: requireAuth,
      name: "LeagueManagement",
    },
    {
      name: "Timeslots",
      path: "/timeslots",
      component: Timeslots,
      beforeEnter: requireAuth,
    },
    {
      path: "/leagues",
      component: Leagues,
      beforeEnter: requireAuth,
    },
    {
      path: "/leagues/new",
      component: LeagueForm,
      beforeEnter: requireAuth,
      name: "LeagueForm",
    },
    {
      path: "/seasons/new",
      component: SeasonForm,
      beforeEnter: requireAuth,
    },
    {
      path: "/venues/new",
      component: VenueForm,
      beforeEnter: requireAuth,
    },
    {
      path: "/divisions/new",
      component: DivisionForm,
      beforeEnter: requireAuth,
    },
    {
      path: "/divisions/:division_id/edit",
      component: DivisionForm,
      beforeEnter: requireAuth,
    },
    {
      path: "/leagues/:league_id",
      component: League,
      beforeEnter: requireAuth,
    },
    {
      path: "/seasons/:season_id",
      component: Season,
      beforeEnter: requireAuth,
    },
    {
      path: "/seasons/:season_id/people/new",
      component: PersonEdit,
      beforeEnter: requireAuth,
    },
    {
      path: "/venues/:venue_id/edit",
      component: VenueForm,
      beforeEnter: requireAuth,
    },
    {
      path: "/venues/:venue_id",
      component: Venue,
      beforeEnter: requireAuth,
    },
    {
      path: "/people/new",
      component: PersonEdit,
      beforeEnter: requireAuth,
    },
    {
      path: "/people/:person_id",
      component: Person,
      beforeEnter: requireAuth,
    },
    {
      path: "/people/:person_id/edit",
      component: PersonEdit,
      beforeEnter: requireAuth,
    },
    {
      path: "/divisions/:division_id",
      component: Division,
      beforeEnter: requireAuth,
    },
    {
      path: "/teams/new",
      component: TeamForm,
      beforeEnter: requireAuth,
    },
    {
      path: "/teams/:team_id/edit",
      component: TeamForm,
      beforeEnter: requireAuth,
    },
    {
      path: "/divisions/:division_id/schedule",
      component: ScheduleForm,
      beforeEnter: requireAuth,
    },
    {
      path: "/teams/:team_id",
      component: Team,
      beforeEnter: requireAuth,
    },
    {
      path: "/calendar/:schedule_id",
      component: Calendar,
      beforeEnter: requireAuth,
      name: "Calendar",
    },
    {
      path: "/schedules/:schedule_id",
      component: Schedule,
      name: "ScheduleTable",
      beforeEnter: requireAuth,
    },
    {
      path: "/schedules",
      component: ScheduleList,
      beforeEnter: requireAuth,
    },
    {
      path: "/tournaments",
      component: TournamentList,
      beforeEnter: requireAuth,
    },
    {
      path: "/public-webpage",
      component: PublicWebpage,
      name: "PublicWebpage",
      beforeEnter: requireAuth,
    },
    {
      path: "/confirmation",
      component: EmailConfirmation,
    },
    {
      path: "/sign-in",
      component: Signin,
      beforeEnter: requireNoAuth,
    },
    {
      path: "/sign-up",
      component: Signup,
      beforeEnter: requireNoAuth,
    },
    {
      path: "/sign-up/wizard",
      name: "SignupWizard",
      component: SignupWizard,
    },
    {
      path: "/:locale(en|ja)/sign-in",
      component: Signin,
      beforeEnter: requireNoAuth,
    },
    {
      path: "/:locale(en|ja)/sign-up",
      component: Signup,
      beforeEnter: requireNoAuth,
    },
    {
      path: "/:locale(en|ja)/sign-up/wizard",
      component: SignupWizard,
      beforeEnter(to, from, next) {
        checkLocale(to);
        next();
      },
    },
    {
      path: "/:locale(en|ja)/wizard",
      component: Wizard,
      name: "Wizard with Locale",
      beforeEnter(to, from, next) {
        checkLocale(to);
        next();
      },
    },
    {
      path: "/",
      component: Dashboard,
      beforeEnter: requireAuth,
    },
    {
      path: "/leagues",
      component: Leagues,
      beforeEnter: requireAuth,
    },
    {
      path: "/sign-out",
      beforeEnter(to, from, next) {
        const currentLocale = localStorage.getItem('locale') || 'en';
        store.dispatch("signOut");        
        next(`/${currentLocale}/sign-in`);
      },
    },
    {
      path: "/public/:domain/schedules",
      component: PublicSchedules,
      name: "PublicSchedules",
      props: wrapMetaProps,
      beforeEnter: redirectToCactuswarePublicDomain,
    },
    {
      path: "/public/:domain/scores",
      component: PublicScores,
      name: "PublicScores",
      props: wrapMetaProps,
      beforeEnter: redirectToCactuswarePublicDomain,
    },
    {
      path: "/public/:domain/standings",
      component: PublicStandings,
      name: "PublicStandings",
      props: wrapMetaProps,
      beforeEnter: redirectToCactuswarePublicDomain,
    },
    {
      path: "/public/:domain/team/:team_id",
      component: PublicTeam,
      name: "PublicTeam",
      props: wrapMetaProps,
      beforeEnter: redirectToCactuswarePublicDomain,
    },
    {
      path: "/public/:domain",
      component: PublicHome,
      name: "PublicHome",
      props: wrapMetaProps,
      beforeEnter: redirectToCactuswarePublicDomain,
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

function wrapMetaProps(to) {
  return to.meta.props;
}

function checkPublicDomain(to, from, next) {
  const url = to.params.domain;

  if (url) {
    from.meta.props = { public: true };

    api.getPublicWebpageByDomain(url).then(response => {
      if (response.data.id) {
        const showTeamsPage = response.data.show_teams_page;
        const showStandingsPage = response.data.show_standings_page;
        const showSchedulesPage = response.data.show_schedules_page;
        const showScoresPage = response.data.show_scores_page;
        const showRostersPage = response.data.show_rosters_page;
        const leagueName = response.data.leagueName;
        const homeTextHTML = response.data.home_text;

        // Meta content
        let metaDiv = document.createElement("div");
        metaDiv.innerHTML = homeTextHTML;
        const description = metaDiv.textContent || metaDiv.innerText || "";

        const metaContent = {
          title: `${leagueName} | Diamond Scheduler`,
          meta: [{ name: "description", content: description.slice(0, 160) }],
        };

        to.meta.props = {
          seasonId: response.data.seasons[0].id,
          domain: url,
          logoUrl: response.data.logo_url,
          organizationName: response.data.organization_name,
          leagueName,
          metaContent,
          homeTextHTML,
          showTeamsPage,
          showStandingsPage,
          showSchedulesPage,
          showScoresPage,
          showRostersPage,
        };

        const routeMap = {
          PublicStandings: showStandingsPage,
          PublicTeam: showTeamsPage,
          PublicSchedules: showSchedulesPage,
          PublicScores: showScoresPage,
        };

        if (routeMap.hasOwnProperty(to.name) && !routeMap[to.name]) {
          return next({ path: url, name: to.name, domain: url });
        }

        next();
      } else {
        next({ path: "/" });
      }
    });
  } else {
    next({ path: "/" });
  }
}

function redirectToCactuswarePublicDomain(to, from, next) {
  const url = to.params.domain;

  from.meta.props = { public: true };

  if (url) {
    api.getPublicWebpageByDomain(url).then(response => {
      if (response.data.id) {
        const PublicOrganizationUrl = `${process.env.VUE_APP_LANDING_PAGE_URL || "http://localhost:5000"}/leagues/${response.data.slug}`;

        if (response.data.redirectUrl)
        {
          const routeMap = {
            PublicStandings: "/standings",
            PublicTeam: `/team/${to.params.team_id}`,
            PublicSchedules: "/schedules",
            PublicScores: "/scores",
          };
    
          if (routeMap.hasOwnProperty(to.name)) {
            window.location.href = PublicOrganizationUrl + `/${response.data.redirectUrl.slug}` + routeMap[to.name];
          }
          else
          {
            window.location.href = PublicOrganizationUrl; 
          }
        }
        else
        {
          window.location.href = PublicOrganizationUrl; 
        }
      }
      else {
        next({ path: "/" });
      }
    });
  }
}

function requireAuth(to, from, next) {
  checkLocale(to);
  if (store.getters.isAuthenticated) {
    next();
  } else {
    if (to.path != "/") {
      next({
        path: "/sign-in?return=" + to.path,
      });
    } else {
      next({
        path: "/sign-in",
      });
    }
  }
}

function requireNoAuth(to, from, next) {
  checkLocale(to);
  if (store.getters.isAuthenticated) {
    next({ path: "/" });
  } else {
    next();
  }
}

function requireAuthWithToast(to, from, next) {
  checkLocale(to);
  if (store.getters.isAuthenticated) {
    next();
  } else {
    Vue.toasted.show("You need to sign in or sign up before continuing!");
    if (to.path != "/") {
      next({
        path: "/sign-in?return=" + to.path,
      });
    } else {
      next({
        path: "/sign-in",
      });
    }
  }
}

function checkLocale(to) {
  const locale = to.params.locale;
  if (["ja", "en"].includes(locale)) {
    store.commit("setLocale", locale);
  }
  i18n.locale = store.getters.locale || "en";
}
